import React, { useState } from "react";
import Header from "../Header";
import SideBar from "../SideBar";
import axios from "axios";
import { useHistory } from "react-router-dom";

function CreateCategory() {
  const history = useHistory();
  const [categoryName, setcategoryName] = useState("");

  const handleName = ({ target }) => setcategoryName(target.value);


  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const data = {
        categoryName,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}bundle/create-category`,
        data
      );
      if (response) {
        history.push("/admin/view-category");
      }
    } catch {}
  };

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <SideBar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 className="h2 fw-bold">Create Category</h1>
            </div>
            <div className="col-md-6">
              <form onSubmit={handleSubmit}>
                <div className="form-outline mb-4">
                  <label className="form-label" htmlFor="weight">
                    Name
                  </label>
                  <input
                    type="text"
                    id="categoryName"
                    className="form-control"
                    name="categoryName"
                    onChange={handleName}
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary2 btn-block mb-4"
                >
                  Add Category
                </button>
              </form>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default CreateCategory;
